import styled from 'styled-components';
export var HeightSpacer = styled.div.withConfig({
  displayName: "spacer__HeightSpacer",
  componentId: "sc-ny0uy5-0"
})(["height:", "px;"], function (props) {
  return props.size || 24;
});
export var WidthSpacer = styled.div.withConfig({
  displayName: "spacer__WidthSpacer",
  componentId: "sc-ny0uy5-1"
})(["width:", "px;"], function (props) {
  return props.size || 24;
});